function normalizeSearch(value) {
  return String(value || '').normalize('NFKC').replace(/[يى]/g, 'ی').replace(/ك/g, 'ک')
    .replace(/[۰-۹٠-٩]/g, digit => String(digit.charCodeAt(0) >= 0x6f0 ? digit.charCodeAt(0) - 0x6f0 : digit.charCodeAt(0) - 0x660))
    .replace(/[\u200c\u200d\u200e\u200f\u0640]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
}
const labPath = lab => `/labs/${lab.slug}`;
function matchesLab(lab, value) {
  const query = normalizeSearch(value);
  if (!query) return true;
  if (normalizeSearch(lab.name).includes(query)) return true;
  const digits = query.replace(/[^0-9]/g, '');
  return digits.length > 0 && !/[\p{L}]/u.test(query) && lab.records.some(record => record.phones.some(phone => phone.number.includes(digits)));
}
module.exports = { normalizeSearch, labPath, matchesLab };
